module.exports = __webpack_public_path__ + "img/i-cursor.5e4fd8d3.svg";